import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network";

export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: fetchBaseQuery({ baseUrl: apiBaseUrl }),
    endpoints: (builder) => ({
        loginAdmin: builder.mutation({
            query: (body) => ({ url: "/backend/v1/auth/login", method: "POST", body: body }),
        })
    })
})

export const { useLoginAdminMutation } = authApi;